import { Ticket } from '../../store/Ticket';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const listTickets = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'number', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<Ticket>>({
    url: buildAdvancedQueryURL(mergedFilters, 'tickets'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const createTicketData = (ticketData: Ticket) => {
  return apiService.callExternalApi<Ticket>({
    url: `${API_SERVER_URL}/tickets`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: ticketData
  });
};

export const getTicket = (id: string) => {
  return apiService.callExternalApi<Ticket>({
    url: `${API_SERVER_URL}/tickets/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const putTicket = (ticket: Ticket) => {
  return apiService.callExternalApi<Ticket>({
    url: `${API_SERVER_URL}/tickets/${ticket.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: ticket
  });
};

export const listTicketsByAsset = (id: string) => {
  return apiService.callExternalApi<Ticket[]>({
    url: `${API_SERVER_URL}/tickets/asset/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listTicketsByPA = (id: string) => {
  return apiService.callExternalApi<Ticket[]>({
    url: `${API_SERVER_URL}/tickets/provisional-asset/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listTicketsByRPMAcct = (id: string) => {
  return apiService.callExternalApi<Ticket[]>({
    url: `${API_SERVER_URL}/tickets/rpm-account/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listTicketsByCustomer = (id: string) => {
  return apiService.callExternalApi<Ticket[]>({
    url: `${API_SERVER_URL}/tickets/customer/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const deleteTicket = (id: string) => {
  return apiService.callExternalApi<Ticket>({
    url: `${API_SERVER_URL}/tickets/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
